import styled from 'styled-components';

export const Content = styled.div`
  padding: 15px 15px 5px;
`;

export const Item = styled.div`
  margin: 0 0 30px;
`;

export const Link = styled.a`
  position: relative;
  top: 10px;
  left: 10px;
  color: var(--cp-accent, #3ea5ff);
  font-weight: bold;
  transition: 0.2s ease-in color;
  &:hover {
    color: ${(props) => (props.theme.theme === 'dark' ? '#fff' : '#000')};
  }
`;
